/* istanbul ignore file */
import FileUpload, { filesPropType } from './FileUpload';

export { filesPropType };
export default FileUpload;
